import { render, staticRenderFns, recyclableRender, components } from "./cu-custom.vue?vue&type=template&id=a987f07a&scoped=true&"
var renderjs
import script from "./cu-custom.vue?vue&type=script&lang=js&"
export * from "./cu-custom.vue?vue&type=script&lang=js&"
import style0 from "./cu-custom.vue?vue&type=style&index=0&id=a987f07a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../software/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a987f07a",
  null,
  false,
  components,
  renderjs
)

export default component.exports